import React from 'react';
import { Button } from '@mui/material';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import { useBackdropContext } from '../../context/backdrop';
import './index.scss';

type CustomBackdropProps = {
  loading?: boolean;
  btnTitle?: string;
  onClick?: () => void;
};

export const CustomBackdrop: React.FC<CustomBackdropProps> = ({ loading, btnTitle, onClick }) => {
  const { backdropOpen } = useBackdropContext();
  const isOpen = backdropOpen || !!loading;

  if (!isOpen) return null;

  return (
    <Backdrop classes={{ root: 'backdrop' }} open>
      <div className="backdrop-content">
        <CircularProgress color="inherit" size={!(btnTitle && onClick) ? 70 : 90} />
        {btnTitle && onClick && (
          <Button className="circle-button" onClick={onClick}>
            {btnTitle}
          </Button>
        )}
      </div>
    </Backdrop>
  );
};
